"use client";
import React from "react";
import { motion } from "framer-motion";
import { cn } from "@/app/_utils/cd";

const COLOR_SCHEMES = {
  purple: {
    colors: [
      'rgb(116, 80, 219)',
      'rgb(62, 136, 246)',
      'rgb(62, 235, 246)'
    ]
  },
  blue: {
    colors: [
      'rgb(0, 119, 182)',
      'rgb(0, 180, 216)',
      'rgb(144, 224, 239)'
    ]
  },
  red: {
    colors: [
      'rgb(220, 38, 38)',
      'rgb(248, 113, 113)',
      'rgb(254, 202, 202)'
    ]
  }
};

export const BackgroundBeams = ({ 
  className,
  colorScheme = 'purple',
  beams = 3 // default to all beams for best effect
}) => {
  const scheme = COLOR_SCHEMES[colorScheme] || COLOR_SCHEMES.purple;
  
  // Create separate motion divs for each beam
  const renderBeams = () => {
    const beamStyles = [
      {
        background: `linear-gradient(197.37deg, ${scheme.colors[0]} -0.38%, rgba(138, 234, 240, 0) 101.89%)`,
        transform: 'translate(-10%, -30%)',
        width: '120%', // Wider than viewport
        left: '0%',
      },
      {
        background: `linear-gradient(115.93deg, ${scheme.colors[1]} 4.86%, rgba(62, 180, 246, 0.33) 38.05%, rgba(62, 235, 246, 0) 74.14%)`,
        transform: 'translate(10%, -10%)',
        width: '120%', // Wider than viewport
        left: '20%',
      },
      {
        background: `radial-gradient(56.47% 76.87% at 6.92% 7.55%, ${scheme.colors[2]}B3 0%, ${scheme.colors[1]}2E 52.16%, ${scheme.colors[2]}00 100%)`,
        transform: 'translate(30%, 10%)',
        width: '120%', // Wider than viewport
        left: '40%',
      }
    ];

    return beamStyles.slice(0, beams).map((style, index) => (
      <motion.div
        key={index}
        initial={{ opacity: 0.5, scale: 1 }}
        animate={{
          scale: [1, 1.1, 1],
          opacity: [0.3, 0.4, 0.3],
        }}
        transition={{
          duration: 8,
          ease: "easeInOut",
          repeat: Infinity,
          delay: index * 0.2, // Slight delay between beams
        }}
        className="absolute rounded-[30rem]"
        style={{
          ...style,
          height: 'min(1200px, 140vh)', // Taller
          filter: 'blur(calc(min(100px, 8vw)))', // Adjusted blur
          willChange: 'transform, opacity',
          position: 'absolute',
          top: '50%',
          transform: `${style.transform} translateY(-50%)`, // Center vertically
          zIndex: '10000',
        }}
      />
    ));
  };

  return (
    <div className={cn(
      "fixed -z-10 h-full w-full inset-0 overflow-hidden",
      className
    )}>
      <div className="relative w-full h-full">
        {renderBeams()}
      </div>
    </div>
  );
};

BackgroundBeams.displayName = "BackgroundBeams";